import { useColorMode } from "@chakra-ui/react";
import { Button, Row, Container, Col } from "react-bootstrap";
import "aos/dist/aos.css";
import "../pages/styles/sections.css";

const TalentTrackSection = () => {
  const { colorMode } = useColorMode();

  return (
    <section
      className={`talent-track-section ls-after-header-second landing-section text-center ${colorMode}`}
      data-aos="fade-up"
      id="talent-track-section"
      aria-labelledby="talent-track-heading"
      style={{ fontFamily: "Roboto, sans-serif" }}
    >
      <Container>
        <Row className="align-items-center justify-content-center text-section">
          <Col xs={12} md={10} lg={8}>
            <h1 id="talent-track-heading" className="text-color">
              Your Gateway to Success with Prometric
            </h1>
            <p className="lead text-color mt-3">
              At the American Academy & TalentTrack, we are dedicated to
              empowering individuals through comprehensive assessment and
              training solutions. As a proud strategic partner of Prometric, we
              provide a seamless pathway for test takers to register for their
              Prometric exams while offering exceptional support and valuable
              resources. Whether you are applying to a university program,
              pursuing professional licensure in healthcare, or exploring
              international career opportunities, our medical licensing exam
              services will help you move confidently toward your goals.
            </p>
            <Button className="DiscoverButton mt-4" href="#Courses-section">
              Discover Courses
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TalentTrackSection;
